import { useCallback, useEffect, useState } from "react";
import { usePage } from "../../hooks/usePage";
import { Loading, PageHero } from "../../components/site/Blocks";
import { SpeakerAvatar, SpeakerCard, SpeakerProfile, speakerSlug } from "../../components/site/SpeakerCard";
import { api } from "../../lib/api";

export default function Speakers() {
  const { section, loading } = usePage("speakers");
  const [speakers, setSpeakers] = useState(null);
  const [open, setOpen] = useState(null);
  useEffect(() => { api.get("/public/speakers").then((r) => setSpeakers(r.data)).catch(() => setSpeakers([])); }, []);
  const fromHash = useCallback(() => {
    const h = decodeURIComponent(window.location.hash.slice(1));
    setOpen(h ? (speakers || []).find((s) => speakerSlug(s) === h) || null : null);
  }, [speakers]);
  useEffect(() => { fromHash(); window.addEventListener("hashchange", fromHash); return () => window.removeEventListener("hashchange", fromHash); }, [fromHash]);
  const show = (s) => { window.history.replaceState(null, "", `#${speakerSlug(s)}`); setOpen(s); };
  const close = () => { window.history.replaceState(null, "", window.location.pathname + window.location.search); setOpen(null); };
  if (loading) return <Loading />;
  const intro = section("intro");
  return (
    <div data-testid="speakers-page">
      {intro && <PageHero eyebrow={intro.eyebrow} title={intro.heading} subtitle={intro.body} />}
      <section className="bg-[#F5F7FA] py-16">
        <div className="container-site">
          {speakers?.length === 0 && <p className="text-lg text-[#4A5568]" data-testid="speakers-empty">Speakers will be announced soon.</p>}
          <ul className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4" data-testid="speakers-grid">
            {(speakers || []).map((s) => <SpeakerCard key={s.id} s={s} onOpen={show} />)}
          </ul>
          {Object.entries((speakers || []).filter((s) => s.session).reduce((g, s) => ({ ...g, [s.session]: [...(g[s.session] || []), s] }), {})).map(([title, ppl]) => (
            <section key={title} className="mt-16 rounded-lg bg-paleblue p-8" data-testid={`panel-${title.toLowerCase().replace(/\s+/g, "-")}`}>
              <p className="text-xs font-semibold uppercase tracking-[0.25em] text-burgundy">Panel</p>
              <h2 className="mt-2 text-2xl text-navy sm:text-3xl">{title}</h2>
              <ul className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
                {[...ppl].sort((a, b) => (a.session_role === "Moderator" ? -1 : b.session_role === "Moderator" ? 1 : a.order - b.order)).map((s) => (
                  <li key={s.id} className="flex items-center gap-3 rounded bg-white p-4">
                    <SpeakerAvatar s={s} size="h-12 w-12 shrink-0" text="text-base" />
                    <span><b className="block text-navy">{s.name}</b><span className="text-sm text-burgundy">{s.session_role || "Panellist"}</span></span>
                  </li>))}
              </ul>
            </section>))}
        </div>
      </section>
      <SpeakerProfile s={open} onClose={close} />
    </div>
  );
}
